import { useState, useEffect } from 'react'

import { getIntlObject } from '@/checkout-instore-legacy/i18n/utils'
import * as CustomEvent from '@/checkout-instore-legacy/utils/CustomEvent'

export const useIntl = () => {
  // It will probably won't get a null value from the start, but just in case we have a fallback
  const defaultIntl = getIntlObject() || {
    locale: 'pt',
    formatMessage: () => '',
  }
  const [intl, setIntl] = useState(defaultIntl)

  useEffect(() => {
    const newIntlCallback = (event: Event) => {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'data' does not exist on type 'Event'.
      const newIntl = event.data
      setIntl(newIntl)
    }

    CustomEvent.listenEvent('intl.updated.instore', newIntlCallback)

    return () => {
      CustomEvent.unlistenEvent('intl.updated.instore', newIntlCallback)
    }
  }, [])

  return intl
}
